const NON_LOCAL_SERVICE_VEHICLE_NAMES = [
  'mini segment',
  'sedan',
  'zedan',
  '7 seater',
]

const normalizeVehicleName = (name) =>
  String(name || '').trim().toLowerCase().replace(/\s+/g, ' ')

export const isLocalServiceVehicle = (vehicle) => {
  const name = normalizeVehicleName(vehicle?.vehicle_name || vehicle?.name)
  if (!name) return true

  return !NON_LOCAL_SERVICE_VEHICLE_NAMES.some(
    (excluded) => name === excluded || name.includes(excluded),
  )
}

export const filterLocalServiceVehicles = (vehicles = []) =>
  vehicles.filter(isLocalServiceVehicle)
